var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"transparent",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"title font-weight-bold"},[_c('span',{},[_vm._v(" 개발자 도구 ")])]),_c('v-card-subtitle',[_vm._v(" 시스템에 심각한 장애를 초래할 수 있습니다. ")]),_c('v-card-actions',[_c('v-btn',{on:{"click":_vm.test}},[_vm._v("test")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }